import React from 'react';
export var UnableSchedulePage = function () {
    return (React.createElement("div", { className: "result-cont text-center w-50 center-auto", style: { paddingTop: 120 } },
        React.createElement("div", { className: "result-cricle warning" },
            React.createElement("span", { className: "iconfont icon-close" })),
        React.createElement("h3", null, "There is no technician available to take on this work order now. Please check back later.")));
};
export default UnableSchedulePage;
